import React, { useEffect, useState } from 'react';
import { cellRendererCheck, currencyFormat, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import { ModuleAccess } from 'utils/moduleaccess';

const FormularyTable = ({
  data,
  onExport,
  loading,
  filters,
  totalSize,
  onPageChange,
  coveredEntityID,
  refetch,
  toggleSider,
  collapseSider,
  setLoading,
  onSearchColumnFilters,
  reset,
}) => {
  const [state, updateState] = useState({
      tableData: [],
      backUpData: [],
      filters: filters,
  });
  const [hasExportPermission, setHasExportPermission] = useState(false);
  useEffect(() => {
    setState({ tableData: data, backUpData: data });
}, [data]);
    const setState = (obj) => updateState(pre => ({...pre, ...obj}));

    useEffect(() => {
      setState({ filters: filters });
  }, [filters]);

  useEffect(() => {
    setHasExportPermission(ModuleAccess("FOR", "EXP"));
  }, []);

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
        setState({
            filters: filter,
        });
        let colFilterOn = { ...filter, filters: colChangedFilter };
        return onPageChange(colFilterOn, true);
    }
    setState({
        filters: filter,
    });
    onPageChange(filter);
};

const handleFilterCancel = () => {
    refetch(true);
};

const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
        const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
        onSearchColumnFilters(filter);
        setState({
            filters: filter,
        });
    }
};

const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
        setState({
            filters: filter,
        });
        let colFilterOn = { ...filter, filters: colChangedFilter };
        onPageChange(colFilterOn, true);
    } else {
        setState({
            filters: filter,
        });
        onPageChange(filter);
    }
};

const handleSort = (filter, hasColFilter) => {
    setState({
        filters: filter,
    });
    if (hasColFilter) {
        onPageChange(filter, true);
    } else {
        onPageChange(filter);
    }
};

    const columns = [
      {
        dataField: 'option',
        text: 'Options',
        sort: false,
        width: 100,
        show: true,
        hideColFilter: true,
        action: true,
        cellRenderer: () => '',
      },
        {
          dataField: 'ndc',
          text: 'NDC',
          sort: true,
          width: 144,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        },
        {
          dataField: 'drugName',
          text: 'Drug Name',
          sort: false,
          width: 288,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
          hideColFilter: true,
        },
        {
          dataField: 'drugManufacturerName',
          text: 'Mfg. Name',
          sort: false,
          width: 144,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
          hideColFilter: true,
        },{
          dataField: 'brandGenericFlag',
          text: 'Brand or Generic',
          sort: false,
          width: 144,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
          hideColFilter: true,
        },{
          dataField: 'packageSize',
          text: 'Package Size',
          sort: false,
          width: 144,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
          hideColFilter: true,
        },{
          dataField: 'wacPackagePrice',
          text: 'Retail Cost',
          sort: false,
          width: 144,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
          hideColFilter: true,
        },
        {
          dataField: 'status340B',
          text: '340B Status',
          sort: false,
          width: 144,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
          hideColFilter: true,
        },
        {
          dataField: 'formularyType',
          text: 'Formulary Type',
          sort: false,
          width: 144,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
          hideColFilter: true,
        },
        {
          dataField: 'Reason',
          text: 'Reason',
          sort: false,
          width: 144,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
          hideColFilter: true,
        },
        {
          dataField: 'statusChangeEffectiveDate',
          text: 'Status Change Effective Date',
          sort: false,
          width: 144,
          show: true,
          inputType: 'text',
          cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
          hideColFilter: true,
        },
        
  ]
  
  const { filters: colFilter, backUpData } = state;
   
  return (
    <div>
    <h5 className="f-16 text-primary font-weight-700">
      Formulary Count ({totalSize})
    </h5>
    <hr />
    <div
    className="table-card scroll-table position-relative border-0 rounded pt-0"
fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
>
      <ReactStrapTable
        id='Formulary-table'
        fixedColumn
        data={backUpData}
       // loading={loading}
        columns={columns}
        onPageSizeChange={onPageSizeChange}
        pageSize={colFilter.pageSize}
        onExport={onExport}
        hasPagination
        onPageChange={onHandlePageChange}
        currentPage={colFilter.currentPage}
        totalRecords={totalSize}
        handleSort={handleSort}
        onFilterCancel={handleFilterCancel}
        filters={colFilter}
        onSearchColumnFilters={handleSearchColumnFilters}
        hasExportPermission={hasExportPermission}
        collapseSider={collapseSider}
        enabletogglesider={true}
        toggleSider={toggleSider}
      />

</div>
</div>
  )
}

export default FormularyTable;